import { Injectable } from '@angular/core';
import { RequestStateManagerService } from '@shared/services';
import { AuthRequestPacCommercialState } from '@shared/model';

@Injectable()
export class AuthRequestPacCommercialStateManagerService extends RequestStateManagerService<AuthRequestPacCommercialState> {
  get defaultState(): AuthRequestPacCommercialState {
    return {
      authDetails: null,
      orderingProvider: null,
      servicingFacility: null,
      diagnoses: null,
      documents: null,
      clinicalInformation: {},
    };
  }
}
